import SectionHeading from '@/components/base/SectionHeading';
import { VOICES } from '@/mocks/schedule';

export default function AboutVoices() {
  const [featured, ...rest] = VOICES;

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50" aria-labelledby="about-voices-heading">
      <div className="max-w-6xl mx-auto">
        <SectionHeading id="about-voices-heading" eyebrow="Feedback" title="用户口碑" desc="来自往届选手和长期关注赛事的朋友的真实反馈。" />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-5">
          <figure className="lg:col-span-7 rounded-lg border border-primary-200 bg-primary-50 p-7 md:p-9 flex flex-col">
            <span className="w-10 h-10 flex items-center justify-center">
              <i className="ri-double-quotes-l text-3xl text-primary-400"></i>
            </span>
            <blockquote className="mt-5 flex-1 font-heading text-lg md:text-2xl text-foreground-900 leading-relaxed">
              {featured.text}
            </blockquote>
            <figcaption className="mt-7 pt-5 border-t border-primary-200 flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading font-bold">
                {featured.name.slice(0, 1)}
              </span>
              <span>
                <span className="block text-sm font-medium text-foreground-950">{featured.name}</span>
                <span className="block text-xs text-foreground-500 mt-0.5">{featured.role}</span>
              </span>
            </figcaption>
          </figure>

          <div className="lg:col-span-5 flex flex-col gap-5">
            {rest.map((v) => (
              <figure key={v.name} className="flex-1 rounded-lg border border-background-200 bg-background-100 p-6 flex flex-col">
                <blockquote className="flex-1 text-sm text-foreground-700 leading-relaxed">{v.text}</blockquote>
                <figcaption className="mt-5 pt-4 border-t border-background-200 flex items-center gap-3">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-500 text-background-50 text-xs font-heading font-bold">
                    {v.name.slice(0, 1)}
                  </span>
                  <span>
                    <span className="block text-sm font-medium text-foreground-950">{v.name}</span>
                    <span className="block text-xs text-foreground-500 mt-0.5">{v.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}